import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../services/authService";
import Icon from "../../components/Common/Icon";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authService.forgotPassword(email.trim());
      // Hesap enumerasyonunu önlemek için her durumda başarı ekranı gösterilir.
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error ?? "İstek gönderilemedi. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10 p-4">
      <div className="w-full max-w-md bg-surface-card rounded-3xl shadow-modal p-8">
        {sent ? (
          <div className="text-center">
            <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-4">
              <Icon name="mark_email_read" className="!text-[28px]" />
            </div>
            <h1 className="text-xl font-bold text-on-surface">E-postanızı Kontrol Edin</h1>
            <p className="text-on-surface-variant text-sm mt-1">
              Girdiğiniz adres sistemde kayıtlıysa, şifre sıfırlama bağlantısı
              gönderildi. Bağlantı 2 saat geçerlidir.
            </p>
            <button
              onClick={() => navigate("/login")}
              className="mt-6 text-primary font-semibold hover:underline"
            >
              Giriş sayfasına dön
            </button>
          </div>
        ) : (
          <>
            <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-4">
              <Icon name="lock_reset" className="!text-[28px]" />
            </div>
            <h1 className="text-2xl font-bold text-on-surface">Şifremi Unuttum</h1>
            <p className="text-on-surface-variant text-sm mt-1">
              Hesabınıza kayıtlı e-posta adresini girin; size yeni şifre belirleme
              bağlantısı gönderelim.
            </p>

            {error && (
              <div className="mt-4 flex items-center gap-2 text-sm text-error bg-error/10 rounded-xl px-4 py-3">
                <Icon name="error" className="!text-[18px]" /> {error}
              </div>
            )}

            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1.5 text-on-surface-variant">
                  E-posta
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ornek@salon.com"
                  className="w-full border border-outline-variant rounded-xl px-3.5 py-2.5 focus:ring-4 focus:ring-primary/15 focus:border-primary outline-none transition bg-white"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary text-white rounded-xl py-3 font-semibold hover:opacity-90 transition active:scale-[0.99] disabled:opacity-50"
              >
                {loading ? "Gönderiliyor…" : "Sıfırlama Bağlantısı Gönder"}
              </button>
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="w-full text-center text-sm text-on-surface-variant hover:text-primary transition"
              >
                Giriş sayfasına dön
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
